export default "__VITE_ASSET__QePSyLAE__"